import React, {Component} from 'react';
import {
  Route,
  NavLink as Link,
  Redirect,
} from "react-router-dom";

import DashboardTemples from './DashboardTemples';
import UsersList from './UsersList';
import Log from './Log';

/**
 * Class for dashboard page.
 *
 * @class      Dashboard (name)
 */
class Dashboard extends Component {
  render() {
    return (
      <div className="container-fluid dashboard-cont">
        
        <div className="row dashboard-content">

          <Route path="/dashboard/temples" render={props => (
            <DashboardTemples {...props} />
          )} />

          <Route path="/dashboard/users" component={UsersList} />

          <Route path="/dashboard/log" component={Log} />

          <Route exact path="/dashboard">
            <Redirect to="/dashboard/temples" />
          </Route>

        </div>
        
        <div className="bottom-bar">

          {/* bottom tab bar */}
          <div className="btn-group btn-group-justified">
            <Link to="/dashboard/temples" class="btn btn-primary" activeClassName="active">
              <span className="btn-item fa fa-list"></span>
              <span className="btn-item btn-label">Temples</span>
            </Link>

            <Link to="/dashboard/users" class="btn btn-primary" activeClassName="active">
              <span className="btn-item fa fa-user-o"></span>
              <span className="btn-item btn-label">Users</span>
            </Link>

            <Link to="/dashboard/log" class="btn btn-primary" activeClassName="active">
              <span className="btn-item fa fa-file-text-o"></span>
              <span className="btn-item btn-label">Log</span>
            </Link>

          </div>

        </div>

      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./js/Dashboard.js